import type { Route } from '~/interfaces/routes.interfaces'

export const ARTICLE_CREATE: Route = {
  path: '/article/create'
}
